<script lang="ts">
  interface Props {
    id?: string;
    children?: import("svelte").Snippet;
  }

  let { id = undefined, children }: Props = $props();
</script>

<span {id} class="text-Red800 text-base block font-bold leading-6"
  >{@render children?.()}</span
>
